import { render } from "./PlacesCarousel.vue?vue&type=template&id=1cc348a6&ts=true"
import script from "./PlacesCarousel.vue?vue&type=script&lang=ts"
export * from "./PlacesCarousel.vue?vue&type=script&lang=ts"

import "./PlacesCarousel.vue?vue&type=style&index=0&id=1cc348a6&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__